import React, { useEffect, useState } from 'react';
import { ShimmerButton } from "react-shimmer-effects";
import { Link } from 'react-router-dom';
import quiz from '../images/quizHeaderImg.png';
import rewardBg from '../images/rewardClaimBg.png';
import winSatsIcon from '../images/winSatsIcon.png';
import sats from '../images/sats.png';
// import Notify from './notify';
import { MdOutlineQuiz } from "react-icons/md";
// import * as APIHelper from '../Helper/mockAPIFetch';
import * as APIHelper from '../Helper/apiFetch';
import Lottie from "lottie-react";
import CongLottie from '../../src/conglottie.json';
import wowLottie from '../../src/wowlottie.json';


const initiaData = require('./urlEncodeTest.json')
const CLAIMED_REWARDS_MAP = {
    NOT_PLAYED: 0,
    WON_REWARD: 1,
    NO_REWARD: 2
}

const shimmer = [
    {
        rows: 1,
        width: 100,
        height: 24
    },
    {
        rows: 1,
        width: "100%",
        height: 35
    },
    {
        rows: 1,
        width: "100%",
        height: 65
    }
]
const REWARD_TYPE = {
    SATS: 0,
    PERCENTAGE: 1,
    CARDDISCOUNT:3,
    TXNDISCOUNT: 4,
    TXNBBPS: 5,
    TXNSC: 6,
    TXNSATSPAY: 7,
    CARDLOAD: 8,
    CARDUPGRADE: 9,
}

const DailyQuiz = () => {
    const [alreadyClimed, setAlreadyClimed] = useState(initiaData?.streak.alreadyClimedReward);
    const [rewardType, setRewardType] = useState(-1)
    const [bgcolor, setbgcolor] = useState("");
    const [climed, setClimed] = useState(CLAIMED_REWARDS_MAP.NOT_PLAYED);
    const [loading, setLoading] = useState(false);
    const [enableQuiz, setEnableQuiz] = useState(false);

    const quizSteak = initiaData?.streak.quizDetails;
    const statusNotify = initiaData?.notify.isNotifyActive.status;

    useEffect(() => {
        setLoading(true);
        APIHelper.quizInfo().then(resp => {
            if (!resp.error) {
                setEnableQuiz(true);
                setLoading(false);
                setClimed(climed => {
                    if (resp.rewards !== undefined) {
                        setRewardType(x => {
                            switch (resp.rewards.type) {
                                case "sats":
                                    return REWARD_TYPE.SATS
                                case "card_percentage":
                                    return REWARD_TYPE.PERCENTAGE
                                case "card-discount":
                                    return REWARD_TYPE.CARDDISCOUNT
                                case "txn":
                                    return REWARD_TYPE.TXNDISCOUNT
                                case "txn_bbps":
                                    return REWARD_TYPE.TXNBBPS
                                case "sc":
                                    return REWARD_TYPE.TXNSC
                                case "txn_satspay":
                                    return REWARD_TYPE.TXNSATSPAY
                                case "card_load":
                                    return REWARD_TYPE.CARDLOAD
                                case "card_upgrade":
                                    return REWARD_TYPE.CARDUPGRADE
                                default:
                                    return -1
                            }
                        })
                        climed = resp.rewards.value === 0 ? CLAIMED_REWARDS_MAP.NO_REWARD : CLAIMED_REWARDS_MAP.WON_REWARD
                        setAlreadyClimed(aClimed => {
                            aClimed.quizClimedReward.sats = resp?.rewards?.code ? resp?.rewards?.code : resp?.rewards?.value;
                            return aClimed;
                        })
                    }
                    return climed;
                });
            }
        }).catch(error => console.log(error))
    }, [])

    useEffect(() => {
    }, [climed])

    useEffect(() => {
        setbgcolor(quizSteak?.bgColor)
    }, [quizSteak])
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: CongLottie,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const defaultLottie = {
        loop: true,
        autoplay: true,
        animationData: wowLottie,
        rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
        }
    };

    const contentDisplay = () => {
        return (
            <div style={{ position: 'relative' }}>
                {/* <Notify title={"Participate to earn Bitcoin rewards!"} /> */}
                <div>
                    {/* <h2 className='purchaseRectangleBgOne'>{quizSteak.title}</h2> */}
                    <div className='purchaseStreakSubTitle'>{quizSteak.msg1}</div>
                    <img className='quizImg' src={quiz} alt=" " />
                </div>
                <div className='purchaseStreakButton-container' style={{padding:'0px'}}>
                    {
                        enableQuiz ? (
                            <Link to='/quiz' className="shopButton" style={{display: 'flex', justifyContent: 'center', padding: '16px 0px'}} >
                                <MdOutlineQuiz size={19} className="buttonIicon" />
                                {quizSteak.buttonTitle}
                            </Link>) : (
                            <Link to='/' onClick={(event) => event.preventDefault()} style={{display: 'flex', justifyContent: 'center', padding: '16px 0px'}} className="shopButton" >
                                <MdOutlineQuiz size={19} className="buttonIicon" />
                                {quizSteak.buttonTitle}
                            </Link>
                        )
                    }
                </div>
            </div>

        )
    }

    const getRewardMessage = () => {
        switch (rewardType) {
            case REWARD_TYPE.SATS:
                return (
                    <div className='winSats-Title'>
                        <span className='rewardSats'>
                            <span dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.stasClimed.replace('$', alreadyClimed.quizClimedReward.sats)}} />
                        </span>
                    </div>
                    )
            case REWARD_TYPE.PERCENTAGE:
                return (
                    <div className='winSats-Title' 
                        dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.climePerReward.replace('$', alreadyClimed.quizClimedReward.sats)}} 
                    />
                    )
            case REWARD_TYPE.CARDDISCOUNT:
                    return (
                        <div className='winSats-Title'
                        dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.cardDiscount.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                    )
            case REWARD_TYPE.TXNDISCOUNT:
                    return (
                        <div className='winSats-Title'
                        dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.cardAndVoucherTxn.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                    )
            case REWARD_TYPE.TXNBBPS:
                    return (
                        <div className='winSats-Title'
                        dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.bbps.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                    )
            case REWARD_TYPE.TXNSATSPAY:
                    return (
                        <div className='winSats-Title'
                        dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.satsPay.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                    )
            case REWARD_TYPE.TXNSC:
                        return (
                            <div className='winSats-Title'
                            dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.superCoin.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                        )
            case REWARD_TYPE.CARDLOAD:
                        return (
                                <div className='winSats-Title'
                                dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.cardLoad.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                        )
            case REWARD_TYPE.CARDUPGRADE:
                        return (
                            <div className='winSats-Title'
                            dangerouslySetInnerHTML={{__html: alreadyClimed.quizClimedReward.cardUpgrade.replace('$', alreadyClimed.quizClimedReward.sats)}}/>
                        )
            default:
                return (
                    <div className='winSats-Title'>
                    </div>
                )
        }
    }

    const alreadyClimedReward = () => {
        return (
            <div style={{ position: 'relative' }}>
                <div>
                    {/* <h2 className='quizTitle'>{alreadyClimed.quizClimedReward.title} </h2> */}
                    {/* <p className='purchaseStreakSubTitle'>{alreadyClimed.quizClimedReward.msg1}</p> */}
                    <img className='quizImg' src={quiz} alt=" " />
                    <div className='climedReward-container'>
                        {/*  <div className='winSatsIcon-container'>
                            <img src={winSatsIcon} className='winSatsIcon' alt=' ' />
                        </div> */}
                        <div style={{width: '50px', height:'auto'}}>
                        
                        </div>
                        {getRewardMessage()}
                        {/* <div>
                            <img src={rewardBg} alt='' className='climeCardBg' />
                        </div> */}
                    </div>
                </div>
            </div>

        )
    }

    const didntAnswerQuiz = () => {
        return (
            <div style={{ position: 'relative' }}>
                <div>
                    <p className='purchaseStreakSubTitle'>{alreadyClimed.didntAnswerQuiz.msg1}</p>
                    <img className='quizImg' src={quiz} alt=" " />
                    <div className='purchaseStreakButton-container' style={{ padding: '0px' }}>
                        <button to='/' onClick={(event) => event.preventDefault()} disabled={true} style={{ display: 'flex', justifyContent: 'center', padding: '16px 0px', opacity: 0.5 }} className="shopButton" >
                            <MdOutlineQuiz size={19} className="buttonIicon" />
                            {quizSteak.buttonTitle}
                        </button>
                    </div>
                </div>
            </div>

        )
    }

    const shimerLoader1 = () => {
        return (
            <div className="republicquiz-shimmer-effect">
            </div>
        )
    }


    const renderQuizComponent = () => {
        switch (climed) {
            case CLAIMED_REWARDS_MAP.NOT_PLAYED:
                return contentDisplay()
            case CLAIMED_REWARDS_MAP.WON_REWARD:
                return alreadyClimedReward();
            case CLAIMED_REWARDS_MAP.NO_REWARD:
                return didntAnswerQuiz();
            default:
                return contentDisplay()
        }
    }

    return (
        <div>
            <div className='purchaseStreak-sectionOne' style={{ backgroundColor: bgcolor, padding: '20px 20px' }}>
                {loading ? shimerLoader1() : renderQuizComponent()}
            </div>
        </div>
    );
}

export default DailyQuiz;